import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M14.672 7.658 12.6 3.568a1.951 1.951 0 0 0-1.75-1.07H5.142A1.936 1.936 0 0 0 3.4 3.568l-2.07 4.09a.578.578 0 0 0-.06.17.985.985 0 0 0-.02.17v3.56A1.944 1.944 0 0 0 3.2 13.5h9.6a1.95 1.95 0 0 0 1.95-1.94V8a.844.844 0 0 0-.078-.342Zm-9.93-3.41a.445.445 0 0 1 .4-.25h5.71a.472.472 0 0 1 .41.25l1.52 3h-1.74a1.944 1.944 0 0 0-1.62.86l-.49.73a.442.442 0 0 1-.37.19h-1.12a.474.474 0 0 1-.38-.19l-.48-.73a1.958 1.958 0 0 0-1.62-.86h-1.74Zm8.51 7.31a.44.44 0 0 1-.45.44H3.2a.44.44 0 0 1-.45-.44v-2.81h2.21a.451.451 0 0 1 .37.2l.49.72a1.944 1.944 0 0 0 1.62.86h1.12a1.958 1.958 0 0 0 1.62-.86l.48-.72a.483.483 0 0 1 .38-.2h2.21Z';
const draw24px =
  'M22.725,11.831a.284.284,0,0,0-.04-.12.09.09,0,0,0-.01-.05l-3.45-6.89a2.731,2.731,0,0,0-2.46-1.52H7.235a2.731,2.731,0,0,0-2.46,1.52l-3.45,6.89a.808.808,0,0,0-.08.34v6A2.761,2.761,0,0,0,4,20.751H20A2.755,2.755,0,0,0,22.745,18V12A.881.881,0,0,0,22.725,11.831Zm-16.6-6.39a1.227,1.227,0,0,1,1.11-.69h9.52a1.231,1.231,0,0,1,1.12.69l2.91,5.81h-3.71a2.748,2.748,0,0,0-2.29,1.22l-.82,1.22a1.242,1.242,0,0,1-1.04.56h-1.85a1.242,1.242,0,0,1-1.04-.56l-.82-1.22a2.748,2.748,0,0,0-2.29-1.22H3.215ZM21.245,18A1.25,1.25,0,0,1,20,19.251H4A1.257,1.257,0,0,1,2.745,18v-5.25h4.18a1.242,1.242,0,0,1,1.04.56l.82,1.21a2.732,2.732,0,0,0,2.29,1.23h1.85a2.732,2.732,0,0,0,2.29-1.23l.82-1.21a1.242,1.242,0,0,1,1.04-.56h4.17Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const InboxIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'inbox'),
) as IconWithRender;

InboxIcon.displayName = 'InboxIcon';
InboxIcon.propTypes = Icon.propTypes;
InboxIcon.renderIcon = (props) => <InboxIcon {...props} />;
export default InboxIcon;
